import Vue from 'vue';
import Vuex from 'vuex';

import conversation from './conversation';
import tab from './tab';
import offer from './offer';
import region from './region';
import serviceCase from './case';
import vehicleServices from './vehicleServices';
import wizardData from './wizardData';
import vehicleEquipments from './vehicleEquipments';
import capacity from '@/modules/simpleService/store/capacity';
import location from '@/modules/simpleService/store/location';

// import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    conversation,
    tab,
    vehicleServices,
    offer,
    serviceCase,
    wizardData,
    vehicleEquipments,
    region,
    location,
    capacity
  }
  // plugins: [createPersistedState({ paths: ['vehicleIdentification', 'vehicleServices', 'vehicleEquipments', 'offer'] })]
});

export default store;
